import { Component} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ColDef } from 'ag-grid-community';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ReportService } from 'src/app/services/report/report.service';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

interface ExtendedColDef extends ColDef {
  visible?: boolean;
}

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddCustomReportComponent {

  isFormSubmitted = false;
  customReportForm: FormGroup;
  reportTypeList: any[] = [{ name: 'AWB' }, { name: 'Invoice' }];
  userData: any;

  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };

  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'md',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };

  originalColumnDefs: ExtendedColDef[];
  columnDefs: ExtendedColDef[] = [];
  modalRef: NgbModalRef | undefined;
  selectedColumns: string[] = [];
  allColumns: any[] = [];
  allColumnsSelected = true;

  constructor(
    private formBuilder: FormBuilder,
    private appCoreService: AppCoreService,
    private reportService: ReportService,
    private modalService: NgbModal,
    private router: Router,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Custom Report');
    this.columnDefs.forEach((colDef: ExtendedColDef) => {
      colDef.visible = true;
    });
  }

  ngOnInit() {
    this.customReportForm = this.formBuilder.group({
      txtReportName: [null, Validators.required],
      ddlReportType: [null, Validators.required]
    });
    this.checkPermission();
  }

  checkPermission(): any {
    this.userData = this.appCoreService.GetUserData();
    const permission = this.userData.config.filter(x => x.categoryname === 'CustomReports');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  generateCustomReport() {
    this.isFormSubmitted = true;
    if (this.permConfig.isAddAllowed && this.customReportForm.valid) {

      this.selectedColumns = this.columnDefs.filter((colDef: ExtendedColDef) => colDef.visible).map((colDef: ExtendedColDef) => colDef.field);     

      if (this.selectedColumns.length === 0) {
        this.appCoreService.showMessage("Select column first", 'Error', 'error');
        return;
      }
      const obj = {
        reporttype: this.customReportForm.get('ddlReportType').value,
        reportname: this.customReportForm.get('txtReportName').value,
        selectedcolumns: this.selectedColumns,
        allcolumns: this.allColumns,
        createdby: this.userData.userId,
        modifiedby: this.userData.userId,
      }
      // console.log("reqObj",obj);
      try {
        this.ngxLoaderService.start();
        // this.reportService.generateCustomReport(obj).subscribe(res => {
        //   if (res && res.success) {
        //     this.ngxLoaderService.stop();
        //     this.openSuccessDialog("Report Generated Sucessfully");
        //   } else {
        //     this.ngxLoaderService.stop();
        //   }
        // });
      } catch (err) {
        this.ngxLoaderService.stop();
        console.error(err);
      }
    }
  }

  onReportTypeChange(event: any) {
    this.selectedColumns = [];
    const type = event?.name;
  
    if (type) {
      this.ngxLoaderService.start();
      try {
        // console.log("TYPE", type);
        // this.reportService.getDataByReportType(type).subscribe(res => {
        //   this.ngxLoaderService.stop();
        //   if (res && res.success) {
        //     const data = res.data;
        //     // console.log("data", data);
  
        //     if (data && data.length > 0) {
        //       // Generate column definitions from the response
        //       this.columnDefs = data.map(item => ({
        //         headerName: item.column_name.charAt(0).toUpperCase() + item.column_name.slice(1).replace(/_/g, ' '),
        //         field: item.column_name,
        //         visible: true // Default all columns to visible
        //       }));
  
        //       this.allColumns = this.columnDefs.map(column => column.field);
        //       this.updateSelectAllCheckbox();
        //     } else {
        //       // console.log("No data available");
        //       this.columnDefs = [];
        //     }
        //   }
        // }, err => {
        //   this.ngxLoaderService.stop();
        //   console.error(err);
        // });
      } catch (err) {
        this.ngxLoaderService.stop();
        console.error(err);
      }
    } else {
      // Clear column definitions if no report type is selected
      this.columnDefs = [];
    }
  }
  

  onColumnVisibilityChanged() {
    this.updateSelectAllCheckbox();
  }

  onChangeSelectAllCheckbox(event: any) {
    const isChecked = event.target.checked;
    this.columnDefs.forEach((colDef: ExtendedColDef) => {
      colDef.visible = isChecked;
    });
  }

  updateSelectAllCheckbox() {
    this.allColumnsSelected = this.columnDefs.every((colDef: ExtendedColDef) => colDef.visible);
  }

  async openSuccessDialog(msg: any) {
    const result = await Swal.fire({
      title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      showCancelButton: false,
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/reports/customreports']);
    }
  }


}
